export const ASSET_ROOT = '/assets';

export const assetUrl = {
  building: file => `${ASSET_ROOT}/buildings/${file}`,
  character: file => `${ASSET_ROOT}/characters/${file}`,
  monster: file => `${ASSET_ROOT}/monsters/${file}`,
  module: file => `${ASSET_ROOT}/environment/modules/${file}`,
  prop: file => `${ASSET_ROOT}/environment/props/${file}`,
  projectile: file => `${ASSET_ROOT}/projectiles/${file}`,
  weapon: file => `${ASSET_ROOT}/equipment/weapons/${file}`,
  armor: file => `${ASSET_ROOT}/equipment/armor/${file}`,
  item: file => `${ASSET_ROOT}/equipment/items/${file}`
};

let catalogPromise;

export function loadAssetCatalog() {
  if (!catalogPromise) {
    catalogPromise = fetch(`${ASSET_ROOT}/catalog.json`, { cache: 'force-cache' }).then(response => {
      if (!response.ok) throw new Error(`Asset catalog ${response.status}`);
      return response.json();
    });
  }
  return catalogPromise;
}

export function preloadAsset(url) {
  return fetch(url, { cache: 'force-cache', priority: 'low' }).then(response => {
    if (!response.ok) throw new Error(`Asset preload ${response.status}: ${url}`);
    return response.arrayBuffer();
  });
}

export async function preloadGroup(group, limit = 3) {
  const catalog = await loadAssetCatalog();
  const queue = catalog.assets.filter(asset => asset.group === group).map(asset => asset.url);
  let cursor = 0;
  async function worker() {
    while (cursor < queue.length) {
      const url = queue[cursor++];
      try { await preloadAsset(url); } catch { /* The runtime loader retains its fallback. */ }
    }
  }
  await Promise.all(Array.from({ length: Math.min(limit, queue.length) }, worker));
}
